/**
 * 全局loading
 */
import { Loading } from 'element-ui';
import _ from 'lodash';

let needLoadingRequestCount = 0;
let loading;

function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '正在加载',
    background: 'rgba(255, 255, 255, 0)'
  });
}
function startLoading1 () {
  loading = Loading.service({
    lock: true,
    text: '拼命加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
    customClass: 'chainLoading'
  });
}

function endLoading () {
  loading.close();
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};

export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    if (window.location.href.indexOf('industry/chain/index') > -1) {
      startLoading1();
    } else {
      startLoading();
    }
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    _.debounce(tryCloseLoading, 100)(); // 延迟100ms
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading-help.js